<template>
  <div v-show="!isProfileRemoved">
    <TextLabel class="">{{ label }}</TextLabel>
    <!-- <div v-if="lastBattle" class="row mb-4">
      <div class="col">
        <BattleInfo :battle="lastBattle" compact-mode />
      </div>
    </div> -->
    <div class="row">
      <div class="col">
        <router-link class="purple" :to="linkToBattles">
          {{ $t('_web_account_matches_link_label', 'View matches') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ROUTER_NAMES_ACCOUNT from '@/constants/router/account';
import { TOURNAMENT } from '@/constants/accounts';
import TextLabel from '@/components/atoms/TextLabel';
export default {
  name: 'AccountInfoMatches',
  components: {
    TextLabel,
  },
  data() {
    return {
      battles: [],
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccountId: 'accountId' }),
    ...mapGetters(['platformByID', 'gameByID']),
    label() {
      return this.$t('_web_profile-info_matches-header', `Matches`, {
        name: this.account._name,
      });
    },
    linkToBattles() {
      return {
        name: ROUTER_NAMES_ACCOUNT.BATTLES,
        params: {
          ...this.account.params,
          ...this.$route.params,
        },
      };
    },
    queryParams() {
      const params = {};
      if (this.type !== TOURNAMENT) {
        params.accountId = this.accountId === this.myAccountId ? 'my' : this.id;
        params.battleStatuses = null;
      }
      return params;
    },
    lastBattle() {
      return this.battles[0];
    },
    isProfileRemoved() {
      return this.$lodash.get(this, 'account.deleted');
    },
  },
  methods: {
    ...mapActions(['getBattles']),
  },
};
</script>
<style lang="scss">
.purple {
  color: #5a58f2;
  &:hover {
    color: #5a58f2;
    opacity: 0.8;
  }
}
</style>
